// src/components/auth/GoogleButton.jsx
import { useState } from "react";
import { Loader2 } from "lucide-react";

export default function GoogleButton({ onClick, label = "Continue with Google" }) {
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");

  async function handleClick() {
    setLoading(true);
    setError("");
    try {
      await onClick();
    } catch (err) {
      console.error("[GoogleButton] error code:", err.code, err.message);
      const msgs = {
        "auth/popup-closed-by-user":    "Sign-in cancelled.",
        "auth/popup-blocked":           "Popup blocked. Please allow popups for this site.",
        "auth/unauthorized-domain":     "This domain is not authorised for Google sign-in. Add it in Firebase Console → Authentication → Settings → Authorised domains.",
        "auth/account-exists-with-different-credential":
          "An account already exists with this email. Please sign in with your password.",
      };
      setError(msgs[err.code] || `Google sign-in failed (${err.code || "unknown"}). Please try again.`);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <button
        type="button"
        onClick={handleClick}
        disabled={loading}
        className="w-full flex items-center justify-center gap-3 px-4 py-2.5
                   border border-surface-300 rounded-xl bg-white text-ink-700
                   text-sm font-medium hover:bg-surface-50 hover:border-surface-400
                   transition-all duration-150 disabled:opacity-60 shadow-sm">
        {loading
          ? <Loader2 size={17} className="animate-spin text-ink-400" />
          : (
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615Z" fill="#4285F4"/>
              <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18Z" fill="#34A853"/>
              <path d="M3.964 10.707A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.707V4.961H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.039l3.007-2.332Z" fill="#FBBC05"/>
              <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.961L3.964 7.293C4.672 5.163 6.656 3.58 9 3.58Z" fill="#EA4335"/>
            </svg>
          )
        }
        {loading ? "Signing in…" : label}
      </button>
      {error && (
        <p className="text-red-500 text-xs mt-2 text-center">{error}</p>
      )}
    </div>
  );
}
